import ReceptionSection from '@/sections/inventory/reception/reception-section';

export default function ReceptionPage() {
  return <ReceptionSection />;
}
